import { useQuery } from "@tanstack/react-query";
import { getCurrentAuthorities } from "@/Services/institutions.service";

export function useInstitutionAuthorities(institutionId: string | undefined) {
  return useQuery({
    queryKey: ["institution-authorities", institutionId],
    queryFn: () => getCurrentAuthorities(institutionId!),
    enabled: !!institutionId,
  });
}
